var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('div',{staticClass:"fixed top-0 left-0 w-full h-full global-loading"},[_c('div',{staticClass:"absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2"},[_c('weve-spinner',{attrs:{"size":"xl"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }